var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgElite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.171,
    height: 20.608,
    viewBox: "0 0 32.171 20.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7079",
    "data-name": "Group 7079",
    transform: "translate(-1479.914 -1037.148)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18965",
    "data-name": "Path 18965",
    d: "M35.289,27.567a1.628,1.628,0,0,0-2.248-.476,2.016,2.016,0,0,0-.538,2.74s.27-.969.993-.663c.791.335.314,1.831-1.168,2.654a2.881,2.881,0,0,1-4.1-2.711l.837-.62-.377-1.043-.891.659.356.987a2.873,2.873,0,0,1-4.866.018c-.809-1.49-.407-3.008.44-2.866.775.13.482,1.093.482,1.093a2.016,2.016,0,0,0,1.017-2.6,1.628,1.628,0,0,0-2.152-.805,3.538,3.538,0,0,0-1.4-2.384,3.541,3.541,0,0,0-1.4,2.385,1.629,1.629,0,0,0-2.152.805,2.016,2.016,0,0,0,1.017,2.6s-.292-.963.482-1.093c.847-.142,1.249,1.377.44,2.866a2.877,2.877,0,0,1-4.9-.058l.365-1.011-.891-.66-.377,1.043.86.637v.01a2.885,2.885,0,0,1-4.1,2.747C9.526,31,9.05,29.5,9.841,29.168c.723-.306.993.663.993.663a2.015,2.015,0,0,0-.538-2.74,1.629,1.629,0,0,0-2.249.476A3.541,3.541,0,0,0,5.583,26.31l6.144,15.846H31.611L37.754,26.31A3.546,3.546,0,0,0,35.289,27.567Z",
    transform: "translate(1474.331 1015.6)",
    fill: "#f3c603"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18969",
    "data-name": "Path 18969",
    d: "M0,0,22,.016,20.922,2.75,1.031,2.734Z",
    transform: "translate(1485 1055)",
    fill: "#fff",
    opacity: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18970",
    "data-name": "Path 18970",
    d: "M1,0,2,3A1,1,0,0,1,0,3Z",
    transform: "translate(1495 1047)",
    fill: "#227299"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18971",
    "data-name": "Path 18971",
    d: "M.764,0l.764,2.293A.764.764,0,0,1,0,2.293Z",
    transform: "matrix(0.966, 0.259, -0.259, 0.966, 1500.552, 1047)",
    fill: "#227299"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18972",
    "data-name": "Path 18972",
    d: "M.764,0l.764,2.293A.764.764,0,0,1,0,2.293Z",
    transform: "translate(1489.468 1047.764) rotate(-30)",
    fill: "#227299"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElite);
export default __webpack_public_path__ + "static/media/elite.91ea628b5a91e8a7ceed6dbeca12c83c.svg";
export { ForwardRef as ReactComponent };